import React, { Component } from "react"
import { Button, Form, FormInput, Spinner } from "elemental-react16"
import { Loader, Icon } from "semantic-ui-react"
import serialize from "form-serialize"
import Attachments from "components/Attachments/Attachments"
import shop from "shop/shop"
import * as ReactDOM from 'react-dom';
//import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';
import "style/Form.scss"
import prefill from "./prefill"
import { validate } from "schema-utils"

export default class FormCMS extends Component {
  state = {
    loading: false,
    error: false,
    page: false,
    success: false,
    redirect: false,
    files: [],
    isDisabled: true
    
  }
  
  componentDidMount() {
    let slug = this.props.slug
    this.load( slug )
  }
  
  componentWillReceiveProps( props ) {
    let slug = props.slug
    if ( this.state.slug === slug ) return
    this.load( slug )
  }
  
  load( slug ) {
    
    this.setState( { slug, loading: true } )
    shop.form( slug )
      .then( res => {
        return res
      } )
      .then( pages => pages[ 0 ] )
      .then( ( page ) => {
        let { product } = this.props
        this.setState( { page, loading: false }, () => {
          prefill( { session: shop.session, address: shop.store.addresses.baseAddress, product } )
        } )
      } )
      .catch( error => {
        this.setState( { error } )
      } )
  }
  /*doSubmit = () => {
    let user_captcha = document.getElementById('user_captcha_input').value;

    if (validateCaptcha(user_captcha)===true) {
      shop.toast("Captcha korrekt!");
      this.setState({isDisabled: false});

    }

    else {
      shop.toast("Captcha falsch, bitte erneut eingeben!");
      this.setState({isDisabled: true});
        document.getElementById('user_captcha_input').value = "";
    }
};*/

  
  onSubmit = async ( e ) => {

    e.preventDefault()
    if ( this.state.loading ) return
    const form = serialize( e.target, { hash: true } )
    const e0 = form.email
    const e1 = form.contact && form.contact.email
    const e2 = form.contact && form.person.email
    const e3 = form.contact && form.contact.email1
    let email = e0 || e1 || e2 || e3 
    //console.log("email", form)
    {/*try {
      let emailValidation = await shop.fetch( `/shop/rest/data/customertempcheck?email=${email}` );
      if ( emailValidation && emailValidation.validate ) {
        // OK
      } else {
        shop.toast( `<div>
<div class="pb1"><b>${email}</b></div>
          <div class="f5">${translate( "E-Mail bereits verwendet." )}</div>
        </div>` )
        e.preventDefault()
        return false
      }
    } catch (err) {
      // Maybe NOT IMPLEMENTED IN API
      console.log( "Error when validating new customer email", { err } )
    }*/}
    //onSubmit({form})
    // TEST EMAIL
    console.info( `submitting form`, form )
    this.setState( { form, loading: true } )
    shop.service.request( this.state.slug, form )
      .then( response => {
        if ( response.status > 200 ) {
          window.swal( translate("Fehler"), translate("Bitte füllen Sie alle benötigen Felder aus."), "error" )
          this.setState( { response, loading: false, success: false, error: true } )
          return false
        }
        console.log( "response", response )
        this.setState( { response, loading: false, success: true } )
        if ( this.props.onSuccess ) {
          this.props.onSuccess()
        }
        console.log( `Form Response`, response )
      } )
      .catch( response => {
        this.setState( { response, loading: false, success: false, error: true } )
        window.swal( translate("Fehler"), translate("Fehler bei der Übertragung: ") + response, "error" )
      } )
    e.preventDefault()
    return false
  }
  
  render() {
    let { page, form, response, loading } = this.state
    if (!this._captcha) {
      const a = Math.floor(Math.random() * 9) + 1
      const b = Math.floor(Math.random() * 9) + 1
      this._captcha = { q: `${a} + ${b} = ?`, a: String(a + b) }
    }
    const solved = this.state.captchaInput === this._captcha.a    
    if ( !page ) return <div>
      <Loader active/>
    </div>
    let { acf } = page || {}
    let { allowUploads } = acf
    return (
      <div className=" pt4 pl2 pr2">
        <div className="">
          <Form className="Form--cms" onSubmit={this.onSubmit}>
            {page ? <div dangerouslySetInnerHTML={{ __html: page.content.rendered }}></div> : <div>Lade Formular</div>}
            {allowUploads &&
            <div className="pt0 pb5">
              <Attachments accept="'.jpg,.jpeg,.png,.doc,.pdf,.gif'"
                           onChange={( { files } ) => {
                             this.setState( { loading: true } )
                             console.log( `uploading files`, files )
                             if ( files ) {
                               shop.service.params( files )
                    
                                 .then( files => {
                                   console.log( `adding file`, files )
                                   this.setState( { loading: false, files } )
                                 } )
                                 .catch( error => {
                                   console.error( "Error Uploading File:", error )
                                   this.setState( { loading: false } )
                                 } )
                             }
                           }}>
                <Button>{translate("Datei auswählen")}</Button>
                {(this.state.files.length > 0) && <div className="">
                  {this.state.files.slice( 0, 1 ).map( ( file, index ) => <React.Fragment key={file.id}>
                    <div className="pv3">
                      <div className={"black"}>
                        #{index + 1}
                      </div>
                      <div className="b">{file && file.file.name}</div>
                      <FormInput key={file.id} value={file.id} name="attachment"/>
                    </div>
                  </React.Fragment> )}
                </div>}
              </Attachments>
            </div>}
            {/*<Captcha/>*/}
                        {shop.config.plugin && shop.config.plugin.Form_Captcha && <div className="pb3" style={{ display: "flex", alignItems: "center"}}>
								<span style={{ marginRight: 8, fontWeight: 600 }}>{this._captcha.q}</span>
								<input
									value={this.state.captchaInput || ""}
									onChange={e => this.setState({ captchaInput: e.target.value })}
									style={{
										width: 56,
										marginRight: 8,
										padding: "6px 8px",
										borderRadius: 4,
										border: "1px solid #ccc"
									}}
									placeholder="?"
								/>
								<Icon
									name="refresh"
									link
									onClick={() => {
										const a = Math.floor(Math.random() * 9) + 1
										const b = Math.floor(Math.random() * 9) + 1
										this._captcha = { q: `${a} + ${b} = ?`, a: String(a + b) }
										this.setState({ captchaInput: "" })
									}}
								/>
								{solved && <Icon name="check" color="green" style={{ marginLeft: 6 }} />}
							</div>}
            {/*<div><Button className="btn btn-primary" onClick={() => this.doSubmit()}>Captcha überprüfen</Button></div><br/>*/}
            {page.acf.showSubmit !== false && <div className="FormField">
              <Button disabled={shop.config.plugin && shop.config.plugin.Form_Captcha ? !solved : false} submit type="primary">{loading ? <Spinner/> : null}  {translate("Anfrage abschicken")}</Button>
            </div>}
          </Form>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/theme/mags/components/Form/FormCMS.js